// extracted by mini-css-extract-plugin
export var bodyRow = "_dr-d";
export var cardColumns = "_dr-e";
export var ellipsesOverflow = "_dr-2";
export var flatBottomCorners = "_dr-3";
export var flatTopCorners = "_dr-4";
export var headerActionsDropdown = "_dr-f";
export var headerBottomRow = "_dr-c";
export var headerTopRow = "_dr-b";
export var orderDetailsWrapper = "_dr-0";
export var orderInfoContainer = "_dr-1";
export var productDetails = "_dr-9";
export var productImage = "_dr-5";
export var responsiveTable = "_dr-8";
export var shipmentContainer = "_dr-a";
export var tableBottomLeft = "_dr-6";
export var tableBottomRight = "_dr-7";
export var trackingLink = "_dr-g";